import { v4 as uuidv4 } from 'uuid';
import { database } from '../firebase/firebase';
import { ref, set, push, get, remove, update } from 'firebase/database';

export const addExpense = (expense) => ({
    type: 'ADD_EXPENSE',
    expense
});

export const startAddExpense = (expenseData = {}) => {
    return (dispatch, getState) => {

        const uid = getState().auth.uid;

        const {
            description = '',
                note = '',
                amount = 0,
                createdAt = new Date().getTime(),
        } = expenseData;

        const expense = { description, note, amount, createdAt };

        push(ref(database, `users/${uid}/expense`), expense).then((reference) => {
            dispatch(addExpense({
                id: reference.key,
                ...expense
            }))
        })
    };
}

export const removeExpense = ({ id } = {}) => ({
    type: 'REMOVE_EXPENSE',
    id
});

export const startRemoveExpense = ({ id } = {}) => {
    return (dispatch, getState) => {

        const uid = getState().auth.uid;

        remove(ref(database, `users/${uid}/expense/${id}`)).then(() => {
            dispatch(removeExpense({ id }));
        });
    };
};

export const editExpense = (id, update = {}) => ({
    type: 'EDIT_EXPENSE',
    id,
    update
});

export const startEditExpense = (id, updates = {}) => {
    return (dispatch, getState) => {

        const uid = getState().auth.uid;

        return update(ref(database, `users/${uid}/expense/${id}`), updates).then(() => {
            dispatch(editExpense(id, updates));
        });
    }
}

export const setExpense = (expenses) => ({
    type: 'SET_EXPENSE',
    expenses
});

export const startSetExpense = () => {
    return (dispatch, getState) => {

        const uid = getState().auth.uid;

        return get(ref(database, `users/${uid}/expense`)).then((snapshot) => {

            const expenses = [];

            snapshot.forEach((childSnapshot) => {
                expenses.push({
                    id: childSnapshot.key,
                    ...childSnapshot.val()
                })
            });

            dispatch(setExpense(expenses));
        });
    }
}